var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 7.33325H13.9999C14.4613 7.33325 14.6666 7.78968 14.6666 8.24992C13.6603 10.9969 13.1047 12.5247 12.9999 12.8333C12.8494 13.2764 12.6268 13.6666 12.1666 13.6666H2.16659C1.70635 13.6666 1.33325 13.2935 1.33325 12.8333V7.33325Z",
    fill: "#58606E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 6.00008H1.33325V3.50008C1.33325 3.03984 1.70635 2.66675 2.16659 2.66675H6.95471C7.24204 2.66675 7.5091 2.81476 7.66138 3.05842L8.66659 4.66675H12.4999C12.9602 4.66675 13.3333 5.03984 13.3333 5.50008V6.00008Z",
    fill: "#333840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderOpen);
export default __webpack_public_path__ + "static/media/ic_folder_open.6ee664de.svg";
export { ForwardRef as ReactComponent };